import React, { useEffect, useState } from "react";
import "./Heading.css";
import Table from "../tables/table";
import { MdOutlineCancel } from "react-icons/md";

function Heading({
  selectedState,
  selectedTable,
  setSelectedTable,
  username,
  selectedid,
  selectedyear,
  selectedmonth,
  selecteddivision,
  selectedname,
  company,
}) {
  const [register, setRegister] = useState([]);
  const [remittance, setRemittance] = useState([]);
  const [returns, setReturns] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [addActPopup, setAddActPopup] = useState(false);

  const [actUpdate, setActUpdate] = useState({
    act: "",
    forms: "",
    frequency: "",
  });

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const handleTableSelect = (tableName) => {
    setSelectedTable(tableName);
  };

  const getTableData = () => {
    const base = company ? "vendors" : "clients";
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/${base}/get_audit_docs.php`;
    const formData = new FormData();

    formData.append("role", userDetails?.role);

    if (company) {
      if (userDetails?.role === "vendor") {
        formData.append("state", userDetails?.state);
        formData.append("type", selectedTable);
        formData.append("user_id", userDetails?.userid);
        formData.append("year", selectedyear);
        formData.append("month", selectedmonth);
      } else {
        formData.append("user_id", selectedid);
        formData.append("year", selectedyear);
        formData.append("month", selectedmonth);
        formData.append("type", selectedTable);
      }
    } else {
      if (userDetails?.role === "client") {
        formData.append("user_id", userDetails?.userid);
        formData.append("year", selectedyear);
        formData.append("month", selectedmonth);
        formData.append("division", selecteddivision);
        formData.append("type", selectedTable);
      } else {
        formData.append("state", selectedState);
        formData.append("type", selectedTable);
        formData.append("user_id", selectedid);
        formData.append("year", selectedyear);
        formData.append("month", selectedmonth);
        formData.append("division", selecteddivision);
      }
    }

    fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        switch (selectedTable) {
          case "register":
            setRegister(data?.data);
            break;
          case "remittance":
            setRemittance(data?.data);
            break;
          case "returns":
            setReturns(data?.data);
            break;
          case "certifications":
            setCertifications(data?.data);
            break;
          default:
            break;
        }
      })
      .catch((error) => console.error("Error with POST request:", error));
  };

  // ✅ Call getTableData inside useEffect
  useEffect(() => {
    getTableData();
  }, [selectedTable, selectedState]);
  // Fetch Act IDs from the audit table

  // Fetch Act IDs from the audit table

  const confirmCreate = () => {
    if (actUpdate.forms && actUpdate.act && actUpdate.frequency) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/vendors/insert_audit_docs.php`;
      const formData = new FormData();
      formData.append("act", actUpdate.act);
      formData.append("forms", actUpdate.forms);
      formData.append("frequency", actUpdate.frequency);
      formData.append("state", selectedState);
      formData.append("type", selectedTable);

      fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          setAddActPopup(false);
          setActUpdate({ act: "", forms: "", frequency: "" });
          alert(data.message);
          getTableData(); // Refresh table data
        })
        .catch((error) => console.error("Error with POST request:", error));
    } else {
      alert("Please enter all details");
    }
  };

  return (
    <div>
      <div className="buttons">
        {["register", "remittance", "returns", "certifications"].map(
          (table) => (
            <button
              key={table}
              className={`Hbutton ${selectedTable === table ? "active" : ""}`}
              onClick={() => handleTableSelect(table)}
            >
              {table.charAt(0).toUpperCase() + table.slice(1)}
            </button>
          )
        )}
      </div>
      {(userDetails?.role === "cadmin" || userDetails?.role === "sadmin") && (
        <div className="newact">
          <button className="newfield" onClick={() => setAddActPopup(true)}>
            <h3>CREATE ACT</h3>
          </button>
        </div>
      )}

      {/* Popup (Act Form) */}
      {addActPopup && (
        <div className="popup-overlay" onClick={() => setAddActPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="back">
              <button
                type="submit"
                className="cancel_button"
                onClick={() => setAddActPopup(false)}
              >
                <MdOutlineCancel />
              </button>
            </div>
            <h3 className="cname">NEW ACT</h3>
            <div>
              <span className="cname">ACT</span>
              <input
                type="text"
                className="Name"
                placeholder="Act"
                value={actUpdate.act}
                onChange={(e) =>
                  setActUpdate((prev) => ({ ...prev, act: e.target.value }))
                }
                required
              />
              <span className="cname">Forms</span>
              <input
                type="text"
                className="Name"
                placeholder="Forms"
                value={actUpdate.forms}
                onChange={(e) =>
                  setActUpdate((prev) => ({ ...prev, forms: e.target.value }))
                }
                required
              />
              <span className="cname">Frequency</span>
              <select
                className="ds1"
                value={actUpdate.frequency}
                onChange={(e) =>
                  setActUpdate((prev) => ({
                    ...prev,
                    frequency: e.target.value,
                  }))
                }
                required
              >
                <option value="" disabled>
                  Select Frequency
                </option>
                <option value="Monthly">Monthly</option>
                <option value="Quarterly">Quarterly</option>
                <option value="Annually">Annually</option>
                <option value="Half Yearly">Half Yearly</option>
              </select>
              <button className="confirm-btn" onClick={confirmCreate}>
                CREATE
              </button>
            </div>
          </div>
        </div>
      )}

      <Table
        getTableData={getTableData}
        selectedTable={selectedTable}
        selectedState={selectedState}
        username={username}
        selectedid={selectedid}
        selectedyear={selectedyear}
        selectedmonth={selectedmonth}
        selecteddivision={selecteddivision}
        register={register}
        remittance={remittance}
        returns={returns}
        certifications={certifications}
        company={company}
      />
    </div>
  );
}

export default Heading;
